/** Clase raíz para aplicar +1px en fichaResumenTypography.css */
export const FICHA_RESUMEN_ROOT_CLASS = "ficha-resumen-root";

/** Suma 1px a un fontSize numérico (inline styles de la ficha). */
export function fichaResumenFontSize(px) {
  const n = Number(px);
  return Number.isFinite(n) ? n + 1 : px;
}
